/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import fs from 'fs'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};
const SectionTitle = makeShortcode("SectionTitle");
const PreCode = makeShortcode("PreCode");
const ExternalLink = makeShortcode("ExternalLink");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <section>
  <SectionTitle mdxType="SectionTitle">Function Overloading</SectionTitle>
    </section>
    <section>
  <PreCode code={fs.readFileSync(__dirname + '/function-overloading.ts')} mdxType="PreCode" />
  <div className="fragment fade-in">
    <ExternalLink href="//bitbucket.org/mathildetech/alauda-common-snippet/src/master/projects/alauda-common-lib/src/lib/permission/k8s-permission.service.ts#lines-46:207" mdxType="ExternalLink">
      More Complicate Example
    </ExternalLink>
  </div>
    </section>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
